import React from 'react';
import { Group } from 'react-konva';
import { Children } from 'utils/types/react';

export interface WithCursorPointerProps {
  children: Children;
  type: string;
  onMouseEnter?: Function;
  onMouseLeave?: Function;
}

function WithCursor({ children, type, ...props }: WithCursorPointerProps) {
  return (
    <Group
      onMouseEnter={(event) => {
        // @ts-ignore
        const container = event.target.getStage()?.container();

        if (container) {
          container.style.cursor = type;
        }

        props?.onMouseEnter && props?.onMouseEnter();
      }}
      onMouseLeave={(event) => {
        // @ts-ignore
        const container = event.target.getStage()?.container();

        if (container) {
          container.style.cursor = 'default';
        }

        props?.onMouseLeave && props?.onMouseLeave();
      }}>
      {children}
    </Group>
  );
}

export default WithCursor;
